import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { ReturnStruct } from '../../../shared/services/structs/return.struct';
import { AuthPasswordChangeService } from '../../../shared/services/apis/platform/auth-password-change.service';
import { AuthPasswordChangeRequest } from '../../../shared/services/requests/platform/auth-password-change.request';
import { MatRadioModule } from '@angular/material/radio';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-password-change-modal',
    templateUrl: './password-change-modal.component.html',
    styleUrls: ['./password-change-modal.component.css'],
    imports: [CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
        MatOptionModule,
        MatRadioModule,
        MatButtonModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatButtonModule,
        MatCheckboxModule,
        MatSelectModule],
})
export class PasswordChangeModalComponent {
    form: FormGroup;
    isLoading = false;

    hideOld = true;
    hideNew = true;
    hideConfirm = true;

    constructor(
        private dialogRef: MatDialogRef<PasswordChangeModalComponent>,
        private fb: FormBuilder,
        private svc: AuthPasswordChangeService,
        private alert: AlertService
    ) {
        this.form = this.fb.group(
            {
                oldPassword: ['', [Validators.required]],
                newPassword: ['', [Validators.required, Validators.minLength(8)]],
                confirmNewPassword: ['', [Validators.required]]
            },
            { validators: [this.passwordsMatchValidator, this.newDifferentFromOldValidator] }
        );
    }

    private passwordsMatchValidator = (group: AbstractControl): ValidationErrors | null => {
        const n = group.get('newPassword')?.value?.trim() ?? '';
        const c = group.get('confirmNewPassword')?.value?.trim() ?? '';
        if (!n || !c) return null;
        return n === c ? null : { passwordsDontMatch: true };
    };

    private newDifferentFromOldValidator = (group: AbstractControl): ValidationErrors | null => {
        const o = group.get('oldPassword')?.value?.trim() ?? '';
        const n = group.get('newPassword')?.value?.trim() ?? '';
        if (!o || !n) return null;
        return o === n ? { sameAsOld: true } : null;
    };

    get f() { return this.form.controls; }

    close(): void {
        this.dialogRef.close(false);
    }

    save(): void {
        if (this.form.invalid || this.isLoading) return;

        const req: AuthPasswordChangeRequest = {
            oldPassword: this.f['oldPassword'].value,
            newPassword: this.f['newPassword'].value,
            confirmNewPassword: this.f['confirmNewPassword'].value
        };

        this.isLoading = true;
        this.svc.ChangePassword(req).subscribe({
            next: (resp: ReturnStruct) => {
                this.isLoading = false;
                if (resp?.isError) {
                    this.alert.show('Erro ao alterar senha: ', (resp.errorDescription ?? 'Falha desconhecida'), AlertType.error);
                    return;
                }
                this.alert.show('Sucesso', 'Senha alterada', AlertType.success);
                this.dialogRef.close(true);
            },
            error: (err) => {
                this.isLoading = false;
                this.alert.show('Erro', 'Erro ao alterar senha.', AlertType.error);
                console.error(err);
            }
        });
    }
}
